import urls from '../../../constants/urls';

import { gatherErrors } from '../../../utils/errorHandling';
import { paginationParams } from '../../../utils/pagination';

import { uniqBy } from 'lodash';

import { ORGANISATIONS_API_CLIENT } from '../../../middleware/multiClientHandler';

export const CLEAR_ORGANISATIONS = 'admin/organisations/CLEAR_ORGANISATIONS';
export const ORGANISATIONS_LOAD_FAILED =
  'admin/organisations/ORGANISATIONS_LOAD_FAILED';
export const ORGANISATIONS_LOAD_SUCCESS =
  'admin/organisations/ORGANISATIONS_LOAD_SUCCESS';
export const LOADING_ORGANISATIONS =
  'admin/organisations/LOADING_ORGANISATIONS';

export const ALL_ORGANISATIONS_LOAD_SUCCESS =
  'admin/organisations/ALL_ORGANISATIONS_LOAD_SUCCESS';
export const LOADING_ALL_ORGANISATIONS =
  'admin/organisations/LOADING_ALL_ORGANISATIONS';
export const ALL_ORGANISATIONS_LOAD_FAILED =
  'admin/organisations/ALL_ORGANISATIONS_LOAD_FAILED';

export const CREATE_ORGANISATION_FAILED =
  'admin/organisations/CREATE_ORGANISATION_FAILED';
export const CREATE_ORGANISATION_SUCCESS =
  'admin/organisations/CREATE_ORGANISATION_SUCCESS';
export const CREATING_ORGANISATION =
  'admin/organisations/CREATING_ORGANISATION';

const initialState = {
  organisations: [],
  allOrganisations: [],
  createErrors: {},

  failedCreating: false,
  failedLoading: false,
  failedLoadingAllOrg: false,

  hasLoaded: false,

  isCreating: false,
  isLoading: false,
  isLoadingAllOrgs: false,

  page: 1,
  pages: 1,
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ORGANISATIONS:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case CLEAR_ORGANISATIONS:
      return initialState;

    case ORGANISATIONS_LOAD_SUCCESS:
      return {
        ...state,
        organisations: action.payload.data.data,
        ...paginationParams(
          action.payload.headers['link'],
          action.payload.headers['x-total']
        ),
        isLoading: false,
        failedLoading: false,
        hasLoaded: true,
      };

    case LOADING_ALL_ORGANISATIONS:
      return {
        ...state,
        isLoadingAllOrgs: true,
        failedLoadingAllOrg: false,
      };

    case ALL_ORGANISATIONS_LOAD_SUCCESS:
      const orgList = state.allOrganisations.concat(action.payload.data.data);

      return {
        ...state,
        allOrganisations: uniqBy(orgList, 'id'),
        ...paginationParams(
          action.payload.headers['link'],
          action.payload.headers['x-total']
        ),
        isLoadingAllOrgs: false,
        failedLoadingAllOrg: false,
      };

    case ALL_ORGANISATIONS_LOAD_FAILED:
      return {
        ...state,
        isLoadingAllOrgs: false,
        failedLoadingAllOrg: true,
      };

    case CREATING_ORGANISATION:
      return {
        ...state,
        createErrors: {},
        isCreating: true,
        failedCreating: false,
      };

    case CREATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        createErrors: {},
        isCreating: false,
      };

    case CREATE_ORGANISATION_FAILED:
      return {
        ...state,
        createErrors: gatherErrors(action.error, 'create_organisation_failed'),
        isCreating: false,
        failedCreating: true,
      };

    default:
      return state;
  }
};

export const createOrganisation = params => dispatch => {
  const organisationParams = {
    name: params.name,
    master_key: params.master_key,
    nhs_session_length_in_hours: params.nhs_session_length_in_hours,
    messaging_enabled: params.messaging_enabled,
    nhs_auth_enabled: params.nhs_auth_enabled,
    role_based_messaging_enabled: params.role_based_messaging_enabled,
    critical_alerts_enabled: params.critical_alerts_enabled,
    message_storage_duration: params.message_storage_duration,
  };

  return dispatch({
    types: [
      CREATING_ORGANISATION,
      CREATE_ORGANISATION_SUCCESS,
      CREATE_ORGANISATION_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        method: 'post',
        url: urls.organisationsApi.organisations.admins.create,
        data: { organisation: organisationParams },
      },
    },
  });
};

export const loadOrganisations = (page = 1, searchTerm) => dispatch => {
  return dispatch({
    types: [
      LOADING_ORGANISATIONS,
      ORGANISATIONS_LOAD_SUCCESS,
      ORGANISATIONS_LOAD_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        url: urls.organisationsApi.organisations.admins.index,
        params: { page, search_string: searchTerm },
      },
    },
  });
};

export const loadAllOrganisations = (page = 1) => dispatch => {
  return dispatch({
    types: [
      LOADING_ALL_ORGANISATIONS,
      ALL_ORGANISATIONS_LOAD_SUCCESS,
      ALL_ORGANISATIONS_LOAD_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        url: urls.organisationsApi.organisations.admins.index,
        params: { page, per_page: 50 },
      },
    },
  });
};

export const clearOrganisations = () => dispatch => {
  return dispatch({
    type: CLEAR_ORGANISATIONS,
  });
};
